import _ from 'lodash';
import { PERSONAL_INFO_SECTION, FINANCIAL_INFO_SECTION } from '../pages/ApplyPage/ApplyPageForm/ApplyPageFormConstants';
import { formatNumber } from '../components/PhoneGroup/PhoneNumber/PhoneNumberUtils';
import { PHONE_TYPE } from '../components/PhoneGroup/PhoneType/PhoneTypeUtils';
import { FLOW_TYPE } from '../../framework/App/AppConstants';

export const getInitialFormValues = (state) => {
    if (_.get(state, 'form.ppcreditapply.initial')) {
        return _.get(state, 'form.ppcreditapply.initial');
    }

    const flow = _.get(state, 'serverData.flow');
    const phoneTypeIsMobile = _.get(state, 'serverData.user.phoneTypeIsMobile');
    let phoneType = _.get(state, 'serverData.user.phoneType');
    let telephone = _.get(state, 'serverData.user.telephone');

    // US1116125: wrap in try/catch and log error when telephone is malformatted
    if (telephone) {
        try {
            telephone = formatNumber(telephone);
        } catch (error) {
            capeLog && capeLog(`gb:form:getInitialFormValues: telephone_length=${telephone.length}, telephone_error=${error.message}. setting telephone to ''`);
            telephone = '';
        }
    }

    // default to MOBILE if invalid phone_type
    if (_.valuesIn(PHONE_TYPE).indexOf(phoneType) < 0) {
        phoneType = PHONE_TYPE.MOBILE;
    }

    // tesla flow - autofill phone type as either mobile or home
    if (flow === FLOW_TYPE.TESLA) {
        phoneType = phoneTypeIsMobile ? PHONE_TYPE.MOBILE : PHONE_TYPE.HOME;
    }

    const initObj = {
        [PERSONAL_INFO_SECTION]: {
            userTitle: _.get(state, 'serverData.user.userTitle'),
            firstName: _.get(state, 'serverData.user.firstName'),
            lastName: _.get(state, 'serverData.user.lastName'),
            currentAddress: {
                street1: _.get(state, 'serverData.billingAddress.addressLine1'),
                street2: _.get(state, 'serverData.billingAddress.addressLine2'),
                city: _.get(state, 'serverData.billingAddress.city'),
                state: _.get(state, 'serverData.billingAddress.state'),
                postalCode: _.get(state, 'serverData.billingAddress.postalCode'),
            },
            previousAddress: {
                street1: _.get(state, 'serverData.user.currentAddress.street1'),
                street2: _.get(state, 'serverData.user.currentAddress.street2'),
                city: _.get(state, 'serverData.user.currentAddress.city'),
                state: _.get(state, 'serverData.user.currentAddress.state'),
                postalCode: _.get(state, 'serverData.user.currentAddress.postalCode'),
            },
            currentUkResident: _.get(state, 'serverData.user.currentUkResident'),
            oneYearAddress: _.get(state, 'serverData.user.oneYearAddress'),
            residentStatus: _.get(state, 'serverData.user.residentStatus'),
            phoneType,
            telephone
        },
        [FINANCIAL_INFO_SECTION]: {
            employmentStatus: _.get(state, 'serverData.user.employmentStatus'),
            monthlyHousingPayment: _.get(state, 'serverData.user.monthlyHousingPayment'),
            monthlyLivingExpenses: _.get(state, 'serverData.user.monthlyLivingExpenses'),
            netMonthlyIncome: _.get(state, 'serverData.user.netMonthlyIncome')
        }
    };
    return initObj;
};
